import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import ActiveCodeApplication from 'components/ActiveCode/ActiveCodeApplication';
import ActiveCodeApplication2 from 'components/ActiveCode/ActiveCodeApplication2';
import DatePicker from 'components/Date/DatePicker';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useForm } from 'react-hook-form';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'applicationDt', label: '신청일자', minWidth: 100, align: 'center' },
  { id: 'dueDate', label: '만료일자', minWidth: 100, align: 'center' },
  { id: `User.username`, label: '담당자명', minWidth: 140, align: 'center' },
  { id: 'clientKey', label: '사용자키', minWidth: 100, align: 'center' },
  { id: 'activeCode', label: '활성화코드', minWidth: 180, align: 'center' },
  { id: 'requestName', label: '요청자명', minWidth: 180, align: 'center' }
];

export default function ActiveCodeMng() {
  const date = new Date();
  const [srchData, setSrchData] = useState({
    startYmd: moment(date.getTime()).add('-1', 'y'),
    endYmd: moment()
  });
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [openRestore, setOpenRestore] = useState(false);
  const [selected, setSelected] = useState({});

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const getDataList = async (e) => {
    const { startYmd, endYmd, username } = srchData;
    if (!!!startYmd) {
      alert('발급 시작일을 입력해 주세요.');
      return;
    }
    if (!!!endYmd) {
      alert('발급 종료일을 입력해 주세요.');
      return;
    }

    let params = {
      offset,
      page,
      limit: offset,
      startYmd,
      endYmd,
      username
    };

    axios
      .get(`/api/active`, { params })
      .then((response) => {
        if (response.data) {
          const result = response.data;
          setPageCnt(Math.ceil(result.count / offset));
          setRows(result.rows);
          if (e?.target) {
            setPage(1);
          }
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const restoreActiveCode = (row) => (e) => {
    e.stopPropagation();
    setSelected(row);
    setOpenRestore(true);
  };

  const handleCloseRestore = () => {
    setOpenRestore(false);
  };

  useEffect(() => {
    getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        활성화 코드 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item sx={{ width: '100%' }}>
          <Stack direction="row" spacing={2}>
            <DatePicker
              inputFormat={'yyyy-MM-DD'}
              label="발급 시작일"
              value={srchData.startYmd}
              onChange={(newValue) => {
                setSrchData({ ...srchData, startYmd: newValue });
              }}
              renderInput={(params) => <TextField {...params} helperText={null} />}
              disableMaskedInput={true}
            />
            <DatePicker
              inputFormat={'yyyy-MM-DD'}
              label="발급 종료일"
              value={srchData.endYmd}
              onChange={(newValue) => {
                setSrchData({ ...srchData, endYmd: newValue });
              }}
              renderInput={(params) => <TextField {...params} helperText={null} />}
              disableMaskedInput={true}
            />
            <TextField id="usernameSrch" variant="outlined" label="담당자명" value={srchData?.pgmNm || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleClickOpen2}>
              활성화 코드 신청
            </Button>
          </Box>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id}>
                    {columns.map((col, colIdx) => {
                      if (col.id === 'requestName' && !row['preActiveCodeId'] && row['preActiveCodeId'] !== 0 && row['dueDate'] > moment().format('YYYYMMDD')) {
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {row[col.id]}
                            <Button variant="contained" color="primary" size="small" onClick={restoreActiveCode(row)} sx={{ ml: 1 }}>
                              복구
                            </Button>
                          </TableCell>
                        );
                      }
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {col.id.split('.').length != 1 ? eval('row.' + col.id.split('.')[0])[col.id.split('.')[1]] : row[col.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
      </Grid>
      <ActiveCodeApplication open={open} handleClose={handleClose} getDataList={getDataList} />
      <ActiveCodeApplication2 open={open2} handleClose={handleClose2} getDataList={getDataList} />
      <RestoreActiveCode pDatas={selected} open={openRestore} handleClose={handleCloseRestore} getDataList={getDataList} />
    </Paper>
  );
}

const RestoreActiveCode = (props) => {
  const { pDatas, open, handleClose, getDataList } = props;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: {
      clientKey: ''
    }
  });

  const onSubmit = async (data) => {
    const { id } = pDatas;
    data.id = id;

    await axios
      .post(`/api/active/restore`, { ...data })
      .then((response) => {
        alert(response.data.message);
        handleClose();
        getDataList();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  useEffect(async () => {
    reset();
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <DialogTitle id="draggable-dialog-title">활성화 코드 복구</DialogTitle>
      <Box id="restoreForm" component="form" onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Box noValidate sx={{ display: 'block' }}>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>사용자 키</TableCell>
                  <TableCell align="right">
                    <TextField
                      id="clientKey"
                      variant="outlined"
                      size="small"
                      label="사용자 키"
                      sx={{ width: 400 }}
                      autoFocus
                      error={!!errors.clientKey}
                      helperText={errors.clientKey && errors.clientKey.message}
                      {...register('clientKey', {
                        required: '사용자 키를 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
            <Typography sx={{ mt: 2, mx: 4 }}>기존 활성화 코드는 차단됩니다.</Typography>
            <Typography sx={{ mx: 4 }}>한 사용권 당 복구는 한 번입니다.</Typography>
            <Typography sx={{ mx: 4 }}>진행하시겠습니까?</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" type="submit">
            예
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            아니오
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
